import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { DISTANT, LILAC_300, paginationConfig, tokens } from '../../constants';
export var getArrayWithRange = (pageCount, start, end) => {
  if (pageCount < 6) return Array.from({
    length: pageCount
  }, (_, i) => i + 1);
  return Array.from({
    length: pageCount
  }, (_, i) => i + 1).slice(start, end);
};
export var getPaginationStyles = props => {
  var _a;
  var hasRowDropdown = ((_a = props === null || props === void 0 ? void 0 : props.dropdownList) === null || _a === void 0 ? void 0 : _a.length) > 0;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: hasRowDropdown ? 'space-between' : 'flex-end',
      flexWrap: 'wrap'
    },
    leftSection: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    dropdownLabel: {
      marginRight: tokens.spacing.SPACING_16
    },
    dropdownAndInputContainer: {
      position: 'relative',
      width: 136
    },
    dropdownContainer: Object.assign({
      position: 'absolute',
      left: 0,
      top: tokens.spacing.SPACING_48,
      zIndex: 9999,
      width: '100%',
      maxHeight: Dimensions.get('window').height * 0.5,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8,
      borderWidth: 1,
      borderColor: LILAC_300
    }, DISTANT),
    rightSection: Object.assign(Object.assign({
      flexDirection: 'row',
      alignItems: 'center'
    }, hasRowDropdown && {
      marginLeft: tokens.spacing.SPACING_16
    }), {
      zIndex: -1
    }),
    pageNumbers: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    singlePage: {
      paddingHorizontal: tokens.spacing.SPACING_8,
      height: 36,
      justifyContent: 'center'
    },
    multiPages: {
      paddingTop: tokens.spacing.SPACING_8
    }
  });
};
export var getPaginationProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(paginationConfig === null || paginationConfig === void 0 ? void 0 : paginationConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.pagination) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};